module.exports = __webpack_public_path__ + "static/ROSA-a814e6e2e5b22cc0f9779b2c76aaa37b.png";